const GET_DETAIL_COMPANY_BY_ID = 'GET_DETAIL_COMPANY_BY_ID'
const GET_DETAIL_COMPANY_BY_ID_SUCCESS = 'GET_DETAIL_COMPANY_BY_ID_SUCCESS'

const PUT_COMPANY = 'PUT_COMPANY'
const PUT_COMPANY_SUCCESS = 'PUT_COMPANY_SUCCESS'

const POST_COMPANY = 'POST_COMPANY'
const POST_COMPANY_SUCCESS = 'POST_COMPANY_SUCCESS'

const GET_COMPANY_PAGES = 'GET_COMPANY_PAGES'
const GET_COMPANY_PAGES_SUCCESS = 'GET_COMPANY_PAGES_SUCCESS'


const GET_COMPANY_LIST = 'GET_COMPANY_LIST'
const GET_COMPANY_LIST_SUCCESS = 'GET_COMPANY_LIST_SUCCESS'

const CompanyTypes = {
  GET_DETAIL_COMPANY_BY_ID,
  GET_DETAIL_COMPANY_BY_ID_SUCCESS,

  PUT_COMPANY,
  PUT_COMPANY_SUCCESS,

  POST_COMPANY,
  POST_COMPANY_SUCCESS,

  GET_COMPANY_PAGES,
  GET_COMPANY_PAGES_SUCCESS,

  GET_COMPANY_LIST,
  GET_COMPANY_LIST_SUCCESS

}

export default CompanyTypes
